import type { IRevertSummary } from '../../../extViewmodels/sdk/models';

/** Returns true when a revert completed but some contacts were skipped or merge reversals failed. */
export function hasRevertWarnings(summary: IRevertSummary): boolean {
	return (
		summary.contactsSkippedModifiedSinceImport > 0 ||
		summary.contactsMergeRevertFailed > 0 ||
		(summary.mergedContacts ?? []).some(m => !m.reverted)
	);
}
